import React from "react"
import { Table, Form } from 'antd';
import { FieldBase, RegistComponent } from "easyui-core";
import { WfComponentProps } from "../../WfComponent/WfComponentProps";

const columns = [{
    title: 'Name',
    dataIndex: 'name',
    sorter: true,
    render: name => `${name.first} ${name.last}`,
    width: '20%',
}, {
    title: 'Gender',
    dataIndex: 'gender',
    filters: [
        { text: 'Male', value: 'male' },
        { text: 'Female', value: 'female' },
    ],
    width: '20%',
}, {
    title: 'Email',
    dataIndex: 'email',
}];

export class AntTableDemo extends React.Component<any, any> {
    static getDerivedStateFromProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            let datas = [...(nextProps.value || [])]
            return {
                data: datas
            };
        }
        return null;
    }

    constructor(props) {
        super(props);
        const value = props.value || [];
        this.state = {
            data: value,
            pagination: {
                current: 0,
                total: 0
            },
            loading: false,
        };
    }

    triggerChange = (changedValue) => {
        // Should provide an event to pass value to Form.
        const onChange = this.props.onChange;
        if (onChange) {
            onChange(Object.assign({}, this.state, changedValue));
        }
    }




    componentDidMount() {
        this.fetch();
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sorter.field,
            sortOrder: sorter.order,
            ...filters,
        });

    }

    fetch = (params = {}) => {
        console.log('params:', params);
        // this.setState({ loading: true });
        // reqwest({
        //     url: 'https://randomuser.me/api',
        //     method: 'get',
        //     data: {
        //         results: 10,
        //         ...params,
        //     },
        //     type: 'json',
        // }).then((data) => {
        //     const pagination = { ...this.state.pagination };
        //     // Read total count from server
        //     // pagination.total = data.totalCount;
        //     pagination.total = 200;
        //     this.setState({
        //         loading: false,
        //         data: data.results,
        //         pagination,
        //     });
        //     const onChange = this.props.onChange;
        //     if (onChange) {
        //         // onChange(Object.assign({}, this.state.data, []));
        //         onChange(Object.assign([], data.results, []));

        //     }
        // });
    }

    render() {
        return (
            <Table
                columns={columns}
                rowKey={(record: any) => record.login.uuid}
                dataSource={this.state.data}
                pagination={this.state.pagination}
                loading={this.state.loading}
                onChange={this.handleTableChange}
            />
        );
    }
}

export class AntTableForm extends React.Component<any, any> {
    field: FieldBase<any>
    constructor(props) {
        super(props)
        this.field = this.props.field
        this.state = {
            data: []
        }
    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        return (
            <Form.Item {...formItemLayout} label={this.props.field.label}>
                {getFieldDecorator(this.field.key, {
                    rules: [
                        // {
                        // validator: this.field.validator,
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                        // type: 'array'
                        // },
                        // {
                        //     required: this.field.required, message: '必填项!',
                        //     type: 'array'
                        // }
                    ],
                })(
                    <AntTableDemo></ AntTableDemo>
                )}
            </Form.Item>

        )
    }

}

RegistComponent({
    selector: "ef-ant-table",
    component: AntTableForm,
    name: "Ant表格控件"
})